
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { dataSource_hide_store_key } from '@xt/client/dataSource/kindred-spirit'

@Observer
@Component({
  components: {}
})
export default class LocationTip extends Vue {
  @Prop({ default: true }) showRecommend!: boolean
  @Prop({ default: false }) hasLocalPermission!: boolean

  hideLocationTip: boolean = false

  get visible() {
    return this.showRecommend && !this.hasLocalPermission && !this.hideLocationTip
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  @Emit('confirm')
  handleConfirm() {
    this.hideLocationTip = true
  }

  closeLocationTip() {
    this.hideLocationTip = true

    // 未登录情况下不作存储处理
    if (!this.UserInfo.id) return

    localStorage.setItem(dataSource_hide_store_key.hideLocationTipStoreKey, 'true')
  }

  created(): void {
    if (!!localStorage.getItem(dataSource_hide_store_key.hideLocationTipStoreKey) === true) {
      this.hideLocationTip = true
    }
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
